import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom'
import InfoView from 'components/InfoView';
import '../styles/root.css'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { ValidateAccount,resendAvlidation } from 'actions';
import {isEmpty} from 'lodash'
import TimerCount from './TimerCount';
import { history } from "store";
import moment from 'moment-timezone'
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth}) {
    return {
        authUser: auth.authUser,
        token: auth.token,
        success: auth.success,
        Validate: auth.Validate
    };
}

function mapDispatchToProps(dispatch) {
    return {
        ValidateAccount:(Token,Secret) => dispatch(ValidateAccount(Token,Secret)),
        resendAvlidation:(Token) => dispatch(resendAvlidation(Token))
    };
}

class Validation extends Component {
   state = {
          Token: '',
          Pinkod:'',
          errors:'',
          resetTimer:false,
          DisabledInp:false,
          token:this.props.token
        }
    intervalID = null
    componentDidMount=()=>{
        let Token  = decodeURIComponent(this.props.match.params.Token);
        this.setState({
            Token:Token
        })
        this.intervalID = setInterval(
            () => {
                if(!isEmpty(this.props.token)){
                    history.push({
                        pathname: '/app/Lobby',
                      }) 
                }
            },
            500
        );     
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
    }
    sendAvlidation =()=>{
        this.props.ValidateAccount(this.state.Token,this.state.PinKod)
    }
    componentDidUpdate() {
        if (this.props.token !== this.state.token) {
            this.setState({
                token:this.props.token
            })
            
        }
    }
    resendAvlidation =()=>{
        let Token  = decodeURIComponent(this.props.match.params.Token);
        this.props.resendAvlidation(Token)
        this.setState({
            DisabledInp:false,
            resetTimer:true
        })
    }
    onChangeValue=(e)=>{
            this.setState({
                PinKod: e.target.value,
                errors:''
            })
        }
    handleKeyPress =(e)=>{
        if (e.key === "Enter") {            
            if(!isEmpty(e.target.value)){
                this.props.ValidateAccount(this.state.Token,e.target.value)                       
            }  
        }
    }
    setDisabledInp=()=>{
        this.setState({
            DisabledInp:true
        })
    }
    setresetTimer=()=>{
        this.setState({
            resetTimer:false
        })
    }
    render() {
        let date1 = moment()
        let date2 = moment().add(120,"seconds")
        //let date2 = new Date(this.props.Validate);
        let Difference_In_Time = 120;
        
        return (
            <div className="d-flex justify-content-center align-items-center w-100 bg">
                <div className="app-login-container animated slideInUpTiny animation-duration-3">
                    <div className="app-login-main-content">
                        <div className="app-logo-content d-flex align-items-center justify-content-center">
                            <Link className="logo-lg" to="/" title="Notyfile">
                                <img src={require("assets/images/logo.png")} alt="Notyfile" title="Notyfile"/>
                            </Link>
                        </div>
                        <div className="app-login-content">
                            <div className="app-login-header mb-4">
                            </div> 
                            <div className="app-login-form">
                                {
                                    !isEmpty(this.state.Token)?
                                    <> 
                                    <fieldset>
                                    <TextField
                                    label={<IntlMessages id="Verification" />}
                                    fullWidth
                                    onKeyPress={this.handleKeyPress}
                                    onChange={this.onChangeValue}
                                    defaultValue={this.state.PinKod}
                                    error ={this.state.errors?true:false}
                                    helperText= {this.state.errors}
                                    disabled={this.state.DisabledInp}
                                    margin="normal"
                                    className="mt-1 my-sm-3"
                                    variant="outlined"
                                    />
                                   
                                    <div className="mb-3 d-flex align-items-center justify-content-between">
                                        {
                                            isEmpty(this.props.Validate)?
                                            <Button
                                            size="small"
                                            onClick={this.resendAvlidation} 
                                            variant="contained" color="primary">
                                                <IntlMessages id="Resend" />
                                            </Button>
                                            :
                                            <TimerCount
                                            setresetTimer={this.setresetTimer}
                                            setDisabledInp={this.setDisabledInp}
                                            Validate={date2}
                                            //Validate={this.props.Validate}
                                            resetTimer={this.props.resetTimer}
                                            resendAvlidation={this.resendAvlidation}
                                            />
                                        }
                                        {
                                           this.state.DisabledInp === true?"":                                       
                                        <Button
                                        onClick={this.sendAvlidation} 
                                        size="small"
                                        disabled={isEmpty(Difference_In_Time.toString())}
                                        variant="contained" color="primary">
                                            <IntlMessages id="Verify" />
                                        </Button>
                                         }
                                    </div>
                                    </fieldset>
                                </>
                                    :
                                    <>
<div className="mb-3 d-flex align-items-center justify-content-between">
<Link to="/signin"><IntlMessages id="Log.in" /></Link>
</div>
                                    </>
                                }
                                
                            </div>
                        </div>
                    </div>
                    <InfoView/>
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(Validation);